<script>
    import { COLORS, BANNER_NAMES, grid} from './store.js';
    import { onMount } from 'svelte';
	import sortedblocks from '../public/sortedblocks.json';

    let bases = {};
    let dyes = {};
    let charges = {};
    let blocks = {};
    let fillerBlocks = {
        amount: 0,
        checked: false
    };
    let showAsStacks = false;

    onMount(() => {
        $grid.banners.forEach((value, key) => {
            if(value.base !== undefined) {
                bases[value.base] = bases[value.base] ? {amount: (bases[value.base].amount + 1)} : {amount: 1};
            }
            if(value.color !== undefined) {
                dyes[value.color] = dyes[value.color] ? {amount: (dyes[value.color].amount + 1)} : {amount: 1};
            }
            if(value.pattern !== undefined) {
                if(value.pattern === 31 || value.pattern === 32 || value.pattern === 33 || value.pattern === 34 || value.pattern === 35 || value.pattern === 36 ) { 
                    charges[value.pattern] = {checked: false}
                }
            }
            if(value.block !== undefined) {
                blocks[value.block] = blocks[value.block] ? {amount: (blocks[value.block].amount + 1)} : {amount: 1};
            }
        })

        let leftOver = 0;
        if(Object.keys(blocks).length !== 0) {
            Object.entries(blocks).forEach(([key, value]) => {
                leftOver = leftOver + value.amount;
            });
        }
        fillerBlocks.amount = ($grid.width * $grid.height) - leftOver;

    })


</script>

Show as stacks: <input bind:checked={showAsStacks} type="checkbox">

<ul>
    <h3>Banners</h3>
    {#each Object.entries(bases) as [color, status] (color)}
        <li>
            <input bind:checked={status.checked} type="checkbox">
            <span class:checked={status.checked}>
                {#if showAsStacks}
                    {#if Math.floor(status.amount / 16) !== 0}
                        {Math.floor(status.amount / 16)} stacks and
                    {/if}
                    {status.amount % 16}
                {:else}
                    {status.amount}
                {/if}
                x <span style={`color: ${$COLORS[color].hex}`}>█</span> {$COLORS[color].name} banner
            </span>
        </li>
    {/each}
</ul>

<ul>
    <h3>Dyes</h3>
    {#each Object.entries(dyes) as [color, status] (color)}
        <li>
            <input bind:checked={status.checked} type="checkbox">
            <span class:checked={status.checked}>
                {#if showAsStacks}
                    {#if Math.floor(status.amount / 64) !== 0}
                        {Math.floor(status.amount / 64)} stacks and
                    {/if}
                    {status.amount % 64}
                {:else}
                    {status.amount}
                {/if}
                x <span style={`color: ${$COLORS[color].hex}`}>●</span> {$COLORS[color].name} dye
            </span>
        </li>
    {/each}
</ul>

{#if (Object.keys(charges).length !== 0)}
    <ul>
        <h3>Banner patterns</h3>
        {#each Object.entries(charges) as [pattern, status] (pattern)}
            <li>
                <input bind:checked={status.checked} type="checkbox">
                <span class:checked={status.checked}>
                    {$BANNER_NAMES[pattern].ingame}
                </span>
            </li>
        {/each}
    </ul>
{/if}

<ul>
    <h3>Blocks</h3>
    {#each Object.entries(blocks) as [block, status] (block)}
        <li>
            <input bind:checked={status.checked} type="checkbox">
            <span class:checked={status.checked}>
                {#if showAsStacks}
                    {#if Math.floor(status.amount / 64) !== 0}
                        {Math.floor(status.amount / 64)} stacks and
                    {/if}
                    {status.amount % 64}
                {:else}
                    {status.amount}
                {/if}
                 x <span class="capitalize">{sortedblocks[block].name}</span>
            </span>
        </li>
    {/each}
    {#if (fillerBlocks.amount !== 0)}
        <li>
            <input bind:checked={fillerBlocks.checked} type="checkbox">
            <span class:checked={fillerBlocks.checked}>
                {#if showAsStacks}
                    {#if Math.floor(fillerBlocks.amount / 64) !== 0}
                        {Math.floor(fillerBlocks.amount / 64)} stacks and
                    {/if}
                    {fillerBlocks.amount % 64}
                {:else}
                    {fillerBlocks.amount}
                {/if}
                x Polished Andesite (or other filler)
            </span>
        </li>
    {/if}
</ul>

<style>
    ul {
        list-style:none;
        padding:0;
    }
	.checked {
        text-decoration: line-through;
    }
    .capitalize {
        text-transform: capitalize;
    }
</style> 